// apps/web/src/features/clients/components/FieldLengthHint.tsx
//
// Live length feedback for the long free-text client fields. Operators paste
// bank requisites out of documents and hit the 2000-char wire bound; without a
// counter the only feedback is a rejected save (AC-8).
//
// The counter is a description of the field (wired through `ariaDescribedBy`),
// not an alert: it changes on every keystroke and must not be announced each
// time. Only crossing the limit is surfaced as an error by the schema.
import { useTranslation } from 'react-i18next';

export interface FieldLengthHintProps {
  id: string;
  length: number;
  max: number;
}

/** Warn once the remaining room is this small, so the limit is not a surprise. */
const WARN_REMAINING = 100;

export function FieldLengthHint({ id, length, max }: FieldLengthHintProps) {
  const { t } = useTranslation(['clients']);
  const near = max - length <= WARN_REMAINING;
  return (
    <p
      id={id}
      style={{
        margin: '2px 0 0',
        fontSize: 'var(--fz-11)',
        color: near ? 'var(--status-warn-fg)' : 'var(--fg-3)',
        fontVariantNumeric: 'tabular-nums',
      }}
    >
      {t('clients:fields.lengthCounter', { length, max })}
    </p>
  );
}
